module.exports = __webpack_public_path__ + "assets/img/6_464_big.ee2c88a0.jpg";